import { useTranslation } from "react-i18next";
import { DollarSign, TrendingUp, TrendingDown, Bed, Heart, Users, ShieldCheck, Star, Activity, Trophy } from "lucide-react";

const fmt = (v) => typeof v === "number" ? `$${v.toLocaleString()}` : v;
const pct = (v) => typeof v === "number" ? `${v.toFixed(1)}%` : v;

export default function KPIGrid({ kpis }) {
  const { t } = useTranslation();
  if (!kpis) return null;

  const cards = [
    { label: t("hospital.valuation"), value: fmt(kpis.valuation), icon: DollarSign, color: "text-emerald-600" },
    { label: t("hospital.netProfit"), value: fmt(kpis.net_profit), icon: kpis.net_profit >= 0 ? TrendingUp : TrendingDown, color: kpis.net_profit >= 0 ? "text-emerald-600" : "text-red-500" },
    { label: t("hospital.bedOccupancy"), value: pct(kpis.bed_occupancy), icon: Bed, color: "text-blue-600" },
    { label: t("hospital.patientSat"), value: `${kpis.patient_satisfaction}/100`, icon: Heart, color: "text-pink-500" },
    { label: t("hospital.reputation"), value: `${kpis.reputation}/100`, icon: Star, color: "text-amber-500" },
    { label: t("hospital.ranking"), value: `#${kpis.ranking}`, icon: Trophy, color: "text-purple-600" },
    { label: t("hospital.totalBeds"), value: kpis.total_beds, icon: Bed, color: "text-cyan-600" },
    { label: t("hospital.totalStaff"), value: kpis.total_staff, icon: Users, color: "text-indigo-600" },
    { label: t("hospital.safety"), value: `${kpis.safety_rating}/100`, icon: ShieldCheck, color: "text-green-600" },
    { label: t("hospital.patients"), value: kpis.patients_treated, icon: Activity, color: "text-orange-500" },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="kpi-grid">
      {cards.map((k) => (
        <div key={k.label} className="bg-white border border-slate-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-200 animate-fade-in-up">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-400">{k.label}</span>
            <k.icon className={`w-4 h-4 ${k.color}`} />
          </div>
          <p className="text-2xl font-heading font-light text-slate-900 tracking-tighter tabular-nums">{k.value}</p>
        </div>
      ))}
    </div>
  );
}
